// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.Header_stack-order-ham__NQbRN {
  z-index: 99999;
}

.Header_nav-link-bottom__JzMEV a {
  color: #333333;
}
.Header_nav-link-bottom__JzMEV a:hover {
  color: black;
}
.Header_nav-link-bottom__JzMEV .Header_active__aAUID {
  padding-bottom: 6px;
  border-bottom: 4px solid #c7db01;
}

.Header_nav-links__N0Ttt {
  display: flex;
  list-style: none;
  justify-content: flex-end;
  width: 50%;
  height: 100%;
  align-items: center;
  margin-left: auto;
}
.Header_nav-links__N0Ttt li {
  display: flex;
  height: 100%;
}
.Header_nav-links__N0Ttt li .Header_nav-btn-wrapper__\\+Ez8d {
  align-items: baseline;
  min-width: max-content;
}
.Header_nav-links__N0Ttt li .Header_margin-reset__bGIMT {
  margin-left: 0 !important;
}

@media (max-width: 1024px) {
  .Header_line__IL4fU {
    width: 30px;
    height: 3px;
    background: white;
    margin: 5px;
  }
  nav {
    position: relative;
  }
  .Header_hamburger__zXsuz {
    position: absolute;
    cursor: pointer;
    right: 5%;
    top: 50%;
    transform: translate(-5%, -50%);
    z-index: 2;
    outline: none;
  }
  .Header_nav-links__N0Ttt {
    position: fixed;
    background: #333333;
    height: 100%;
    width: 100%;
    flex-direction: column;
    clip-path: circle(10px at 90% -10%);
    -webkit-clip-path: circle(10px at 90% -10%);
    transition: all 0.7s ease-out;
    pointer-events: none;
    z-index: 1;
  }
  .Header_nav-links__N0Ttt li {
    opacity: 0;
  }
  .Header_nav-links__N0Ttt li .Header_nav-btn-wrapper__\\+Ez8d {
    width: 100%;
    align-items: center;
    min-width: auto;
  }
  .Header_nav-links__N0Ttt.Header_open__NF3J4 {
    clip-path: circle(300vh at 90% 0%);
    -webkit-clip-path: circle(300vh at 90% 0%);
    pointer-events: all;
    justify-content: space-around;
  }
  .Header_nav-links__N0Ttt,
  .Header_logout__6V3Rk {
    font-size: 1.5rem;
  }
}
@media (max-width: 1024px) and (max-height: 340px) {
  .Header_nav-links__N0Ttt,
  .Header_logout__6V3Rk {
    font-size: 1rem;
  }
}
@media (max-width: 1024px) {
  li.Header_fade__exSUo {
    opacity: 1;
  }
  .Header_selected__8uo9e {
    width: 100vw;
    justify-content: center;
  }
  li {
    display: flex;
    flex-direction: row;
    text-decoration: none;
  }
  li div {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  li.Header_fade__exSUo.Header_sub-par-menu__qzm-C {
    display: flex;
    background-color: #616161;
    width: 100vw;
    justify-content: center;
    font-size: 1rem;
  }
  li.Header_fade__exSUo.Header_sub-par-menu__qzm-C a.Header_active__aAUID {
    width: 100vw;
    justify-content: center;
    background-color: #505050;
  }
}
.Header_navbar__FZ1Pv {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #333333;
  height: 5rem;
  padding-right: 2.5rem;
}
.Header_navbar__FZ1Pv .Header_left__uzflX {
  padding-left: 2.5rem;
  display: flex;
  align-items: center;
  text-decoration: none;
}
.Header_navbar__FZ1Pv .Header_left__uzflX a {
  padding-left: 1rem;
}
.Header_navbar__FZ1Pv .Header_left__uzflX a img {
  height: 4rem;
}
.Header_navbar__FZ1Pv a,
.Header_navbar__FZ1Pv .Header_dropdown__tGQNh,
.Header_navbar__FZ1Pv .Header_logout__6V3Rk {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding-left: 1rem;
  padding-right: 1rem;
  height: 100%;
  text-decoration: none;
  color: #9d9d99;
}
.Header_navbar__FZ1Pv a:hover,
.Header_navbar__FZ1Pv .Header_dropdown__tGQNh:hover,
.Header_navbar__FZ1Pv .Header_logout__6V3Rk:hover {
  color: white;
}
@media (max-height: 340px) {
  .Header_navbar__FZ1Pv a,
  .Header_navbar__FZ1Pv .Header_dropdown__tGQNh,
  .Header_navbar__FZ1Pv .Header_logout__6V3Rk {
    font-size: 0.8rem;
  }
}
.Header_navbar__FZ1Pv .Header_hidden__Xl2zX,
.Header_navbar__FZ1Pv .Header_carret__sMMNx {
  color: #9d9d99;
  height: 100%;
  outline: none;
}
.Header_navbar__FZ1Pv .Header_hidden__Xl2zX i,
.Header_navbar__FZ1Pv .Header_carret__sMMNx i {
  margin-left: 1rem;
}
.Header_navbar__FZ1Pv .Header_hidden__Xl2zX {
  visibility: hidden;
}
.Header_navbar__FZ1Pv .Header_selected__8uo9e {
  color: white;
}
.Header_navbar__FZ1Pv .Header_selected__8uo9e a,
.Header_navbar__FZ1Pv .Header_selected__8uo9e div, .Header_navbar__FZ1Pv .Header_selected__8uo9e .Header_carret__sMMNx {
  color: white;
}
.Header_navbar__FZ1Pv .Header_selected__8uo9e {
  background-color: #080808;
  height: 100%;
  text-decoration: none;
}
.Header_navbar__FZ1Pv .Header_sub-par-menu__qzm-C {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/utils/_base.scss","webpack://./src/components/Page/Header.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AClCA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACSJ;ADPI;EACI,YAAA;EACA,aAAA;ACSR;ADNI;EACI,gBAAA;ACQR;;ADHA,uBAAA;AAQA,mBAAA;ACZA;EACE,cAAA;AAYF;;AARE;EACE,cAAA;AAWJ;AAVI;EACE,YAAA;AAYN;AATE;EACE,mBAAA;EACA,gCAAA;AAWJ;;AAPA;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAUF;AARE;EACE,aAAA;EACA,YAAA;AAUJ;AARI;EACE,qBAAA;EACA,sBAAA;AAUN;AAPI;EACE,yBAAA;AASN;;AFME;EETA;IACE,WAAA;IACA,WAAA;IACA,iBAAA;IACA,WAAA;EAOF;EALA;IACE,kBAAA;EAOF;EAJA;IACE,kBAAA;IACA,eAAA;IACA,SAAA;IACA,QAAA;IACA,+BAAA;IACA,UAAA;IACA,aAAA;EAMF;EAHA;IAEE,eAAA;IACA,mBFlEW;IEmEX,YAAA;IACA,WAAA;IACA,sBAAA;IACA,mCANgB;IAOhB,2CAPgB;IAQhB,6BAAA;IACA,oBAAA;IACA,UAAA;EAIF;EADE;IACE,UAAA;EAGJ;EADI;IACE,WAAA;IACA,mBAAA;IACA,eAAA;EAGN;EACA;IAEE,kCADmB;IAEnB,0CAFmB;IAGnB,mBAAA;IACA,6BAAA;EAAF;EAEA;;IAEE,iBAAA;EAAF;AACF;AACI;EAJF;;IAKI,eAAA;EAGJ;AACF;AFnDE;EEkDA;IACE,UAAA;EAIF;EADA;IACE,YAAA;IACA,uBAAA;EAGF;EAAA;IACE,aAAA;IACA,mBAAA;IACA,qBAAA;EAEF;EADE;IACE,qBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;EAGJ;EACA;IACE,aAAA;IACA,yBF7HkB;IE8HlB,YAAA;IACA,uBAAA;IACA,eAAA;EACF;EACE;IACE,YAAA;IACA,uBAAA;IACA,yBFpIyB;EEqI7B;AACF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBF/Ia;EEiJb,YA1JW;EA4JX,qBAAA;AAHF;AAIE;EACE,oBAAA;EA1JF,aAAA;EACA,mBAAA;EAEA,qBAAA;AAwJF;AACI;EACE,kBAAA;AACN;AAAM;EACE,YAAA;AAER;AAGE;;;EApKA,aAAA;EACA,mBAAA;EAEA,qBAAA;EAsKE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,cFpKqB;AEoKzB;AACI;;;EACE,YFrKyB;AEwK/B;AAAI;EAdF;;;IAeI,iBAAA;EAKJ;AACF;AAFE;;EAEE,cFhLqB;EEiLrB,YAAA;EACA,aAAA;AAIJ;AAHI;;EACE,iBAAA;AAMN;AAHE;EACE,kBAAA;AAKJ;AAFE;EACE,YF1LmC;AE8LvC;AAHI;;EAEE,YF7LiC;AEkMvC;AATE;EAME,yBFlM4B;EEmM5B,YAAA;EACA,qBAAA;AAMJ;AAHE;EACE,aAAA;AAKJ","sourcesContent":[null,null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.stack-order-ham {\n  z-index: 99999;\n}\n\n.nav-link-bottom a {\n  color: #333333;\n}\n.nav-link-bottom a:hover {\n  color: black;\n}\n.nav-link-bottom .active {\n  padding-bottom: 6px;\n  border-bottom: 4px solid #c7db01;\n}\n\n.nav-links {\n  display: flex;\n  list-style: none;\n  justify-content: flex-end;\n  width: 50%;\n  height: 100%;\n  align-items: center;\n  margin-left: auto;\n}\n.nav-links li {\n  display: flex;\n  height: 100%;\n}\n.nav-links li .nav-btn-wrapper {\n  align-items: baseline;\n  min-width: max-content;\n}\n.nav-links li .margin-reset {\n  margin-left: 0 !important;\n}\n\n@media (max-width: 1024px) {\n  .line {\n    width: 30px;\n    height: 3px;\n    background: white;\n    margin: 5px;\n  }\n  nav {\n    position: relative;\n  }\n  .hamburger {\n    position: absolute;\n    cursor: pointer;\n    right: 5%;\n    top: 50%;\n    transform: translate(-5%, -50%);\n    z-index: 2;\n    outline: none;\n  }\n  .nav-links {\n    position: fixed;\n    background: #333333;\n    height: 100%;\n    width: 100%;\n    flex-direction: column;\n    clip-path: circle(10px at 90% -10%);\n    -webkit-clip-path: circle(10px at 90% -10%);\n    transition: all 0.7s ease-out;\n    pointer-events: none;\n    z-index: 1;\n  }\n  .nav-links li {\n    opacity: 0;\n  }\n  .nav-links li .nav-btn-wrapper {\n    width: 100%;\n    align-items: center;\n    min-width: auto;\n  }\n  .nav-links.open {\n    clip-path: circle(300vh at 90% 0%);\n    -webkit-clip-path: circle(300vh at 90% 0%);\n    pointer-events: all;\n    justify-content: space-around;\n  }\n  .nav-links,\n  .logout {\n    font-size: 1.5rem;\n  }\n}\n@media (max-width: 1024px) and (max-height: 340px) {\n  .nav-links,\n  .logout {\n    font-size: 1rem;\n  }\n}\n@media (max-width: 1024px) {\n  li.fade {\n    opacity: 1;\n  }\n  .selected {\n    width: 100vw;\n    justify-content: center;\n  }\n  li {\n    display: flex;\n    flex-direction: row;\n    text-decoration: none;\n  }\n  li div {\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n  }\n  li.fade.sub-par-menu {\n    display: flex;\n    background-color: #616161;\n    width: 100vw;\n    justify-content: center;\n    font-size: 1rem;\n  }\n  li.fade.sub-par-menu a.active {\n    width: 100vw;\n    justify-content: center;\n    background-color: #505050;\n  }\n}\n.navbar {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: #333333;\n  height: 5rem;\n  padding-right: 2.5rem;\n}\n.navbar .left {\n  padding-left: 2.5rem;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n}\n.navbar .left a {\n  padding-left: 1rem;\n}\n.navbar .left a img {\n  height: 4rem;\n}\n.navbar a,\n.navbar .dropdown,\n.navbar .logout {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  height: 100%;\n  text-decoration: none;\n  color: #9d9d99;\n}\n.navbar a:hover,\n.navbar .dropdown:hover,\n.navbar .logout:hover {\n  color: white;\n}\n@media (max-height: 340px) {\n  .navbar a,\n  .navbar .dropdown,\n  .navbar .logout {\n    font-size: 0.8rem;\n  }\n}\n.navbar .hidden,\n.navbar .carret {\n  color: #9d9d99;\n  height: 100%;\n  outline: none;\n}\n.navbar .hidden i,\n.navbar .carret i {\n  margin-left: 1rem;\n}\n.navbar .hidden {\n  visibility: hidden;\n}\n.navbar .selected {\n  color: white;\n}\n.navbar .selected a,\n.navbar .selected div, .navbar .selected .carret {\n  color: white;\n}\n.navbar .selected {\n  background-color: #080808;\n  height: 100%;\n  text-decoration: none;\n}\n.navbar .sub-par-menu {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stack-order-ham": `Header_stack-order-ham__NQbRN`,
	"nav-link-bottom": `Header_nav-link-bottom__JzMEV`,
	"active": `Header_active__aAUID`,
	"nav-links": `Header_nav-links__N0Ttt`,
	"nav-btn-wrapper": `Header_nav-btn-wrapper__+Ez8d`,
	"margin-reset": `Header_margin-reset__bGIMT`,
	"line": `Header_line__IL4fU`,
	"hamburger": `Header_hamburger__zXsuz`,
	"open": `Header_open__NF3J4`,
	"logout": `Header_logout__6V3Rk`,
	"fade": `Header_fade__exSUo`,
	"selected": `Header_selected__8uo9e`,
	"sub-par-menu": `Header_sub-par-menu__qzm-C`,
	"navbar": `Header_navbar__FZ1Pv`,
	"left": `Header_left__uzflX`,
	"dropdown": `Header_dropdown__tGQNh`,
	"hidden": `Header_hidden__Xl2zX`,
	"carret": `Header_carret__sMMNx`
};
export default ___CSS_LOADER_EXPORT___;
